import {
  Drawer,
  Toolbar,
  List,
  ListItemIcon,
  ListItemText,
  ListItemButton,
  Box,
  IconButton,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import SummarizeTwoToneIcon from "@mui/icons-material/SummarizeTwoTone";
import CloseIcon from "@mui/icons-material/Close";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PeopleIcon from "@mui/icons-material/People";
import BarChartIcon from "@mui/icons-material/BarChart";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import ListAltIcon from "@mui/icons-material/ListAlt";
import SettingsIcon from "@mui/icons-material/Settings";
import ViewCarouselIcon from "@mui/icons-material/ViewCarousel";
import SubscriptionsIcon from "@mui/icons-material/Subscriptions";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import EmailIcon from "@mui/icons-material/Email";
import PsychologyIcon from "@mui/icons-material/Psychology";
import { SIDEBAR_WIDTH } from "../constants";
import SavingsIcon from "@mui/icons-material/Savings";
import Person3Icon from "@mui/icons-material/Person3";
import NoteIcon from "@mui/icons-material/Note";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import QuizIcon from "@mui/icons-material/Quiz";
import PaidIcon from "@mui/icons-material/Paid";
import SmartDisplayIcon from "@mui/icons-material/SmartDisplay";
import HelpCenterIcon from "@mui/icons-material/HelpCenter";
import { PropsWithoutRef } from "react";

interface Props {
  mobileOpen: boolean;
  handleSidebarToggle: () => void;
}

export default function Sidebar({
  mobileOpen,
  handleSidebarToggle,
}: PropsWithoutRef<Props>) {
  const location = useLocation();
  const navigate = useNavigate();

  const drawer = (
    <>
      <Toolbar className="sidebar-logo" sx={{ position: "relative" }}>
        <figure>
          <img
            src="/static/images/logo.png"
            alt=""
            onClick={() => navigate("/dashboard")}
          />
        </figure>
        <IconButton
          sx={{
            position: "absolute",
            top: "10px",
            right: "10px",
            color: "white",
            display: { lg: "none" },
          }}
          onClick={handleSidebarToggle}
        >
          <CloseIcon />
        </IconButton>
      </Toolbar>

      <List sx={{ flexGrow: 1 }} className="sidebr-lst">
        <ListItemButton
          className="lst-itm"
          selected={location.pathname === "/dashboard"}
          onClick={() => navigate("/dashboard")}
        >
          <ListItemIcon>
            <DashboardIcon />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Dashboard" />
        </ListItemButton>

        <ListItemButton
          className="lst-itm"
          selected={location.pathname === "/manageusers"}
          onClick={() => navigate("/manageusers")}
        >
          <ListItemIcon>
            <PeopleIcon />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Manage Users" />
        </ListItemButton>

        <ListItemButton
          className="lst-itm"
          selected={location.pathname === "/manage-courses"}
          onClick={() => navigate("/manage-courses")}
        >
          <ListItemIcon>
            <SmartDisplayIcon />
          </ListItemIcon>
          <ListItemText
            className="lstitm-txt"
            primary="Manage Courses Content"
          />
        </ListItemButton>

        {/* <ListItemButton
          className="lst-itm"
          selected={location.pathname === "/manage-service-provider"}
          onClick={() => navigate("/manage-service-provider")}
        >
          <ListItemIcon>
            <Person3Icon />
          </ListItemIcon>
          <ListItemText
            className="lstitm-txt"
            primary="Manage Service Provider"
          />
        </ListItemButton> */}
        <ListItemButton
          className="lst-itm"
          selected={location.pathname === "/manage-challenges"}
          onClick={() => navigate("/manage-challenges")}
        >
          <ListItemIcon>
            <ListAltIcon />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Manage Challenges" />
        </ListItemButton>
        {/* <ListItemButton
          className="lst-itm"
          selected={location.pathname === "/manage-questionnaire"}
          onClick={() => navigate("/manage-questionnaire")}
        >
          <ListItemIcon>
            <QuizIcon />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Manage Questionnaire" />
        </ListItemButton> */}
        <ListItemButton
          className="lst-itm"
          selected={location.pathname === "/manage-subscriptions"}
          onClick={() => navigate("/manage-subscriptions")}
        >
          <ListItemIcon>
            <SubscriptionsIcon />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Manage Subscriptions" />
        </ListItemButton>

        {/* <ListItemButton
          className="lst-itm"
          selected={location.pathname === "/manage-categories"}
          onClick={() => navigate("/manage-categories")}
        >
          <ListItemIcon>
            <ListAltIcon />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Manage Categories" />
        </ListItemButton> */}
        {/* <ListItemButton
          className="lst-itm"
          selected={location.pathname === "/manage-amenities"}
          onClick={() => navigate("/manage-amenities")}
        >
          <ListItemIcon>
            <ManageAccountsIcon />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Manage Amenities" />
        </ListItemButton> */}

        {/* <ListItemButton
          className="lst-itm"
          selected={location.pathname === "/manage-listed-properties"}
          onClick={() => navigate("/manage-listed-properties")}
        >
          <ListItemIcon>
            <ListAltIcon />
          </ListItemIcon>
          <ListItemText
            className="lstitm-txt"
            primary="Manage Listed Properties"
          />
        </ListItemButton> */}

        <ListItemButton
          className="lst-itm"
          selected={location.pathname === "/manage-surveys"}
          onClick={() => navigate("/manage-surveys")}
        >
          <ListItemIcon>
            <NoteIcon />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Manage Surveys" />
        </ListItemButton>
        <ListItemButton
          className="lst-itm"
          selected={location.pathname === "/manage-community-forum"}
          onClick={() => navigate("/manage-community-forum")}
        >
          <ListItemIcon>
            <ThumbUpIcon />
          </ListItemIcon>
          <ListItemText
            className="lstitm-txt"
            primary="Manage Community Forum"
          />
        </ListItemButton>

        <ListItemButton
          className="lst-itm"
          selected={location.pathname === "/manage-revenue"}
          onClick={() => navigate("/manage-revenue")}
        >
          <ListItemIcon>
            <PaidIcon />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Revenue Management" />
        </ListItemButton>

        <ListItemButton
          className="lst-itm"
          selected={location.pathname === "/manage-notifications"}
          onClick={() => navigate("/manage-notifications")}
        >
          <ListItemIcon>
            <NotificationsActiveIcon />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Manage Notifications" />
        </ListItemButton>
        <ListItemButton
          className="lst-itm"
          selected={location.pathname === "/analytics"}
          onClick={() => navigate("/analytics")}
        >
          <ListItemIcon>
            <BarChartIcon />
          </ListItemIcon>
          <ListItemText
            className="lstitm-txt"
            primary="Reports and Analytics"
          />
        </ListItemButton>
        <ListItemButton
          className="lst-itm"
          selected={location.pathname === "/customer-support"}
          onClick={() => navigate("/customer-support")}
        >
          <ListItemIcon>
            <HelpCenterIcon />
          </ListItemIcon>
          <ListItemText
            className="lstitm-txt"
            primary="Manage Customer Support"
          />
        </ListItemButton>

        <ListItemButton
          className="lst-itm"
          selected={location.pathname === "/cms"}
          onClick={() => navigate("/cms")}
        >
          <ListItemIcon>
            <SummarizeTwoToneIcon />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Manage CMS" />
        </ListItemButton>
        <ListItemButton
          className="lst-itm"
          selected={location.pathname === "/faq"}
          onClick={() => navigate("/faq")}
        >
          <ListItemIcon>
            <QuizIcon />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary=" Manage FAQs" />
        </ListItemButton>

        <ListItemButton
          className="lst-itm"
          selected={location.pathname === "/manage-subAdmin"}
          onClick={() => navigate("/manage-subAdmin")}
        >
          <ListItemIcon>
            <PersonAddIcon />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Manage Sub-Admin" />
        </ListItemButton>
      </List>
    </>
  );

  return (
    <Box
      component="nav"
      sx={{ flexShrink: { lg: 0 } }}
      className="sidebar-main-div"
    >
      <Drawer
        className="sidebar_drawer"
        variant="temporary"
        open={mobileOpen}
        onClose={handleSidebarToggle}
        ModalProps={{
          keepMounted: true,
        }}
        sx={{
          display: { xs: "block", lg: "none" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: SIDEBAR_WIDTH,
          },
        }}
      >
        {drawer}
      </Drawer>
      <Drawer
        variant="permanent"
        className="sidebar_drawer"
        sx={{
          display: { xs: "none", lg: "block" },
          "& .MuiDrawer-paper": {
            width: SIDEBAR_WIDTH,
            boxSizing: "border-box",
          },
        }}
        open
      >
        {drawer}
      </Drawer>
    </Box>
  );
}
